import { TotalSalesIcon } from "src/assets/icons";
import { formatNumberForCurrency } from "src/utils";
import Dropdown from "src/components/Dropdown";
import {
  Container,
  HeaderRow,
  HeaderTitleCell,
  HeaderIcon,
  HeaderTitle,
  Amount,
  FooterRow,
  VerticalDivider,
  UnitsCellContainer,
  UnitsCellNumber,
  UnitsCellLabel,
} from "./TotalSalesSnapshotCard.styles";

interface UnitsCellProps {
  count: number;
  type?: "small" | "large";
  label: string;
}

const UnitsCell = ({ count, type = "small", label }: UnitsCellProps) => (
  <UnitsCellContainer>
    <UnitsCellNumber type={type}>{count}</UnitsCellNumber>
    <UnitsCellLabel>{label}</UnitsCellLabel>
  </UnitsCellContainer>
);

export interface TotalSalesData {
  value?: number;
  units?: {
    total?: number;
    single_wide?: number;
    double_wide?: number;
    triple_wide?: number;
    quad_wide?: number;
  };
}

interface TotalSnapShotCardProps {
  data: TotalSalesData;
  timeRangeType: string;
  setTimeRangeType: (timeRangeType: "mtd" | "qtd" | "ytd") => void;
}

export default ({
  data,
  timeRangeType,
  setTimeRangeType,
}: TotalSnapShotCardProps) => {
  const formattedAmount =
    data.value != null ? formatNumberForCurrency(data.value) : "0";

  return (
    <Container>
      <HeaderRow>
        <HeaderTitleCell>
          <HeaderIcon>
            <TotalSalesIcon />
          </HeaderIcon>
          <HeaderTitle>Total sales</HeaderTitle>
        </HeaderTitleCell>
        <Dropdown
          menuItemsObj={{
            mtd: "Month to date",
            qtd: "Quarter to date", // (Q2) text from comps??
            ytd: "Year to date",
          }}
          selectedItem={timeRangeType}
          onSelectedItemChange={(selectedItem) =>
            setTimeRangeType(selectedItem as "mtd" | "qtd" | "ytd")
          }
        />
      </HeaderRow>
      <Amount>{formattedAmount}</Amount>
      <FooterRow>
        <UnitsCell type="large" count={data.units?.total ?? 0} label="Units" />
        <VerticalDivider />
        <UnitsCell count={data.units?.single_wide ?? 0} label="Single" />
        <UnitsCell count={data.units?.double_wide ?? 0} label="Double" />
        <UnitsCell count={data.units?.triple_wide ?? 0} label="Triple" />
        <UnitsCell count={data.units?.quad_wide ?? 0} label="Quad" />
      </FooterRow>
    </Container>
  );
};
